'use strict';

var _start = require('./start.js');

var _select = require('./select.js');

var _hashNavigation = require('./hashNavigation');

var _subTabs = require('./subTabs');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var App = function App() {
    _classCallCheck(this, App);

    var $body = $('body');
    var $start = $body.find('.start-screen__button');

    if ($start.length) {
        new _start.Start($body);
        new _select.CharSelect($body);
    }

    new _hashNavigation.HashNavigation($body);

    if ($body.find('.trigger-collapse').length) {
        new _subTabs.SubTabs($body);
    }
};

$(function () {
    new App();
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZha2VfMTBiMGQxNTguanMiXSwibmFtZXMiOlsiQXBwIiwiJGJvZHkiLCIkIiwiJHN0YXJ0IiwiZmluZCIsImxlbmd0aCIsIlN0YXJ0IiwiQ2hhclNlbGVjdCIsIkhhc2hOYXZpZ2F0aW9uIiwiU3ViVGFicyJdLCJtYXBwaW5ncyI6Ijs7QUFBQTs7QUFDQTs7QUFDQTs7QUFDQTs7OztJQUVNQSxHLEdBQ0YsZUFBYztBQUFBOztBQUNWLFFBQU1DLFFBQVFDLEVBQUUsTUFBRixDQUFkO0FBQ0EsUUFBTUMsU0FBU0YsTUFBTUcsSUFBTixDQUFXLHVCQUFYLENBQWY7O0FBRUEsUUFBSUQsT0FBT0UsTUFBWCxFQUFtQjtBQUNmLFlBQUlDLFlBQUosQ0FBVUwsS0FBVjtBQUNBLFlBQUlNLGtCQUFKLENBQWVOLEtBQWY7QUFDSDs7QUFFRCxRQUFJTyw4QkFBSixDQUFtQlAsS0FBbkI7O0FBRUEsUUFBR0EsTUFBTUcsSUFBTixDQUFXLG1CQUFYLEVBQWdDQyxNQUFuQyxFQUEyQztBQUN2QyxZQUFJSSxnQkFBSixDQUFZUixLQUFaO0FBQ0g7QUFDSixDOztBQUdMQyxFQUFFLFlBQU07QUFDSixRQUFJRixHQUFKO0FBQ0gsQ0FGRCIsImZpbGUiOiJmYWtlXzEwYjBkMTU4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU3RhcnQgfSBmcm9tICcuL3N0YXJ0LmpzJztcbmltcG9ydCB7IENoYXJTZWxlY3QgfSBmcm9tICcuL3NlbGVjdC5qcyc7XG5pbXBvcnQgeyBIYXNoTmF2aWdhdGlvbiB9IGZyb20gJy4vaGFzaE5hdmlnYXRpb24nO1xuaW1wb3J0IHsgU3ViVGFicyB9IGZyb20gJy4vc3ViVGFicyc7XG5cbmNsYXNzIEFwcCB7XG4gICAgY29uc3RydWN0b3IoKSB7XG4gICAgICAgIGNvbnN0ICRib2R5ID0gJCgnYm9keScpO1xuICAgICAgICBjb25zdCAkc3RhcnQgPSAkYm9keS5maW5kKCcuc3RhcnQtc2NyZWVuX19idXR0b24nKTtcblxuICAgICAgICBpZiAoJHN0YXJ0Lmxlbmd0aCkge1xuICAgICAgICAgICAgbmV3IFN0YXJ0KCRib2R5KTtcbiAgICAgICAgICAgIG5ldyBDaGFyU2VsZWN0KCRib2R5KTtcbiAgICAgICAgfVxuXG4gICAgICAgIG5ldyBIYXNoTmF2aWdhdGlvbigkYm9keSk7XG5cbiAgICAgICAgaWYoJGJvZHkuZmluZCgnLnRyaWdnZXItY29sbGFwc2UnKS5sZW5ndGgpIHtcbiAgICAgICAgICAgIG5ldyBTdWJUYWJzKCRib2R5KVxuICAgICAgICB9XG4gICAgfVxufVxuXG4kKCgpID0+IHtcbiAgICBuZXcgQXBwKCk7XG59KTtcbiJdfQ==